const summary_cards = [
  { label: 'Policies & claims', value: '6', note: 'Tracked', accent: 'dark' },
  { label: 'Active policies', value: '3', note: 'In force', accent: 'green' },
  { label: 'Open claims', value: '2', note: 'In progress', accent: 'amber' },
  { label: 'Renewals due', value: '1', note: 'Action soon', accent: 'red' }
];

const filters = [
  { id: 'all', label: 'All', count: 6, active: true },
  { id: 'policies', label: 'Policies', count: 4 },
  { id: 'claims', label: 'Claims', count: 2 }
];

const rows_by_tab = {
  all: [
    { ref: 'IN-01', item: 'Asset & property insurance', type: 'Policy', value: 'R 48 000 000', status: { label: 'Active', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'IN-02', item: 'Cyber insurance', type: 'Policy', value: 'R 25 000 000', status: { label: 'Renewal due', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'IN-03', item: 'Fleet / vehicle insurance', type: 'Policy', value: 'R 6 200 000', status: { label: 'Active', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'CL-08', item: 'Vehicle accident claim - CA 418-921', type: 'Claim', value: 'R 84 000', status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'IN-04', item: 'Professional indemnity', type: 'Policy', value: 'R 15 000 000', status: { label: 'Active', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'CL-09', item: 'Employee injury claim - warehouse', type: 'Claim', value: 'R 32 000', status: { label: 'Submitted', class: 'bg-warning-subtle text-warning-emphasis' } }
  ],
  policies: [
    { ref: 'IN-01', item: 'Asset & property insurance', type: 'Policy', value: 'R 48 000 000', status: { label: 'Active', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'IN-02', item: 'Cyber insurance', type: 'Policy', value: 'R 25 000 000', status: { label: 'Renewal due', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'IN-03', item: 'Fleet / vehicle insurance', type: 'Policy', value: 'R 6 200 000', status: { label: 'Active', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'IN-04', item: 'Professional indemnity', type: 'Policy', value: 'R 15 000 000', status: { label: 'Active', class: 'bg-success-subtle text-success-emphasis' } }
  ],
  claims: [
    { ref: 'CL-08', item: 'Vehicle accident claim - CA 418-921', type: 'Claim', value: 'R 84 000', status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'CL-09', item: 'Employee injury claim - warehouse', type: 'Claim', value: 'R 32 000', status: { label: 'Submitted', class: 'bg-warning-subtle text-warning-emphasis' } }
  ]
};

export default {
  name: 'ComplyonInsuranceClaims',
  data: () => ({
    summary_cards,
    filters,
    active_tab: 'all',
    rows_by_tab
  }),
  computed: {
    rows() {
      return this.rows_by_tab[this.active_tab] || this.rows_by_tab.all;
    }
  },
  methods: {
    set_tab(tab_id) {
      this.active_tab = tab_id;
    }
  }
};
